module.exports = __webpack_public_path__ + "img/InternationalBusinessTimes.f9fb7939.jpg";